export default __webpack_public_path__ + "static/media/icon-check-fill.c096a66f.svg";